import { render, staticRenderFns } from "./OrderLayout.vue?vue&type=template&id=3454aa6f&scoped=true&"
import script from "./OrderLayout.vue?vue&type=script&lang=js&"
export * from "./OrderLayout.vue?vue&type=script&lang=js&"
import style0 from "./OrderLayout.vue?vue&type=style&index=0&id=3454aa6f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3454aa6f",
  null
  
)

export default component.exports